<template>
  <v-card class="dialog" width="520">
    <v-card-title class="primary">
      <span class="headline">SALVAR COTAÇÃO</span>
      <v-spacer></v-spacer>
      <v-btn icon flat dark :disabled="disableButtons" @click="onFechar">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="dialog-body">
      <div class="message">De qual maneira será salva a cotação?</div>
    </v-card-text>

    <v-card-actions class="dialog-actions">
      <v-layout row wrap align-center justify-center>
        <v-btn
          flat
          class="btn-cancel"
          :disabled="disableButtons"
          @click="onApenasSalvar"
        >
          APENAS SALVAR
        </v-btn>

        <div style="width:24px"></div>

        <v-btn
          class="button-permanecer"
          flat
          :disabled="disableButtons"
          @click="onSalvarELiberar"
        >
          SALVAR E LIBERAR
        </v-btn>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ModalSalvarCotacao",
  props: {
    disableButtons: { type: Boolean, default: false }
  },
  methods: {
    onApenasSalvar() {
      this.$emit("apenas-salvar");
    },
    onSalvarELiberar() {
      this.$emit("salvar-e-liberar");
    },
    onFechar() {
      this.$emit("fechar");
    }
  }
};
</script>

<style scoped>
.headline {
  color: white;
  font-size: 18px !important;
}
.dialog-body {
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 24px;
  padding-bottom: 24px;
}
.message {
  color: #9b9b9b;
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.6px;
}
.dialog-actions {
  padding: 12px 24px 24px 24px;
  justify-content: center;
}
.v-btn.btn-cancel {
  border: 2px solid #0b4f6a;
  color: #0b4f6a;
  text-transform: uppercase;
  font-weight: 600;
  min-width: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalSalvarCotacao.vue